module.exports = __webpack_public_path__ + "img/prescription.465119ef.png";